module.exports = __webpack_public_path__ + "static/media/MobileBackground.431daca9.png";